<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerText]="T.ASSIGN_ASSESSMENT_DIALOG_TITLE | translate"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-file-plus'}"
>
	<ng-container dialogContent>
		<!--ASSESSMENT-->
		<sim-chip-autocomplete
			[dataType]="FetchDataType.Assessment"
			[formCtrl]="assessmentControl"
			[labelToken]="T.ASSIGN_ASSESSMENT_DIALOG_ASSESSMENT"
		>
			<mat-icon labelPrefix fontIcon="fa-ballot-check" fontSet="fad" />
		</sim-chip-autocomplete>

		<!--PARTICIPANT-->
		<sim-autocomplete
			[dataType]="FetchDataType.SimUser"
			(onSelect)="addParticipant($event)"
			[excludeIds]="selectedUserIds()"
			[labelToken]="T.ASSIGN_ASSESSMENT_DIALOG_CANDIDATE"
			[searchFilters]="participantFilter"
			class="participantAutocomplete"
		/>

		<div class="ParticipantsItem">
			<!--TODO: user list item-->
			@for (user of selectedParticipants; track user) {
				<sim-user-list-item (onDelete)="removeParticipant($event)" [user]="user" />
			}
		</div>
	</ng-container>

	<ng-container actions>
		<sim-button (onClick)="close()" [icon]="{fontSet: 'fad', fontIcon: 'fa-times'}" [label]="T.BUTTON_CLOSE" color="warn" />
		<sim-button
			color="accent"
			(onClick)="doClose()"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.BUTTON_SAVE"
			[disabled]="!assessmentControl.value || !selectedParticipants.length"
		/>
	</ng-container>
</sim-basic-material-dialog>
